export const updateEntity = (propName, props) => (value, options) => props.update({ [propName]: value }, options)
